import { render, staticRenderFns } from "./access_rights.vue?vue&type=template&id=ea6d0f1c"
import script from "./access_rights.vue?vue&type=script&lang=js"
export * from "./access_rights.vue?vue&type=script&lang=js"
import style0 from "./access_rights.vue?vue&type=style&index=0&id=ea6d0f1c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports